import React, { useState, useEffect } from "react";
import "../../../Assets/Scss/Home3slider.scss";
import Carousel from 'react-bootstrap/Carousel';
import { getAdBannerByDomainAction } from "../../../Store/actions";
import { useSelector, useDispatch } from "react-redux";
import { getImageUrl } from "../../../Utils/index";
function ControlledCarousel() {
  const dispatch = useDispatch();

  const { adBanners } = useSelector((state) => state.Website);

  React.useEffect(() => {
    dispatch(getAdBannerByDomainAction());
  }, [dispatch]);

  const items = React.useMemo(() => {
    let arr = [];
    adBanners?.forEach((i) => {
      if (i.banner_dimension === "1480 * 630") {
        let obj = {};
        obj.src = getImageUrl(i.image_upload);
        obj.url = i.image_url;
        obj.altText = "ad";
        arr.push(obj);
      }
    });
    return arr;
  }, [adBanners]);

  return (
    <div>
   <div style={{"textAlign":"center","backgroundColor":"#2b3cbb","fontStyle":"italic","hover-color":"blue", margin:"0", padding:"0", "color":"#f2f3ff"}}>
    <p className="hover-overlay" style={{margin:"0", padding:"0"}}>Welcome to Zizoze - Zizoze's Trusted Coupons, Offers & Cashback Website</p>
   </div>
    <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel" style={{marginTop:"0px"}}>
  <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
    {items.map((o)=>{
        return(
  <img onClick={()=>window.open(o?.redirect_url, "_blank")}
  id="slider-img-s" src={o.url || o.src} alt={o.alt}
  style={{width:"100%", cursor:"pointer"}}/>
  )
      })}
    </div>
     <div class="carousel-item">
     {items.map((o)=>{
        return(
  <img onClick={()=>window.open(o?.redirect_url, "_blank")}
  id="slider-img-s" src={o.url || o.src} alt={o.alt}
  style={{width:"100%"}}/>
  )
      })}
    </div>
    <div class="carousel-item">
    {items.map((o)=>{
        return(
  <img onClick={()=>window.open(o?.redirect_url, "_blank")}
  id="slider-img-s" src={o.url || o.src} alt={o.alt}
  style={{width:"100%"}}/>
  )
      })}
    </div> 
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
</div>
 
  );
}
export default ControlledCarousel;
